import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex !important;
  width: fit-content;
  flex-direction: column;
  align-items: center;

  .title {
    font-weight: bold;
    font-size: 12px;
    margin-top: 6px;
    width: 114px;
    text-align: center;
    word-break: break-word;
  }

  .cg-upload {
    display: block;
    border: 1px dashed rgba(0, 0, 0, 0.45);
    border-radius: 6px;
    width: 114px;
    height: 100px;
    transition: border 0.3s;

    &:hover {
      border: 1px dashed #0062ff;
    }

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }

    .ant-upload {
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      height: 100%;
      width: 100%;
    }
  }

  .img-container {
    position: relative;
    border: 1px solid #d9d9d9;
    border-radius: 6px;
    width: 114px;
    height: 100px;

    img {
      width: 100%;
      height: 100%;
      border-radius: 6px;
    }
  }
`;

export const CrossWrapper = styled.div`
  position: absolute;
  background-color: rgba(0, 0, 0, 0.45);
  height: 25px;
  width: 25px;
  right: 0;
  top: 0;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
`;
